// extracted by mini-css-extract-plugin
export default {"container":"Notification_container__A1yZX","message":"Notification_message__VdGQB"};